export const DESELECT_PASSENGER_FOR_DELETION = 'DESELECT_PASSENGER_FOR_DELETION'

export default (passengerId: string) => ({
  type: DESELECT_PASSENGER_FOR_DELETION,
  passengerId,
})
